<template>
	<div>
		<h1>Subgroup and Sensitivity Analysis</h1>

		<InputSelectYesNo
			question="Were subgroup analyses performed?"
			v-model="$tera.project.isSubgroupAnalysis"
			questionMark="metaanalysis-2"
		/>

		<InputTextSingleLineMulti
			v-if="$tera.project.isSubgroupAnalysis"
			question="Which subgroup analyses were performed?"
			v-model="$tera.project.subgroupAnalysis"
			placeholder="e.g. children less than 5 years old and children greater than 5 years old"
			questionMark="metaanalysis-3"
		/>

		<InputTextMultiLine
			v-else
			question="Why was subgroup analysis not performed?"
			v-model="$tera.project.whyNotSubgroupAnalysis"
			questionMark="metaanalysis-4"
		/>

		<InputSelectYesNo
			question="Were sensitivity analyses performed?"
			v-model="$tera.project.isSensitivityAnalysis"
			questionMark="metaanalysis-5"
		/>

		<InputTextSingleLineMulti
			v-if="$tera.project.isSensitivityAnalysis"
			question="Which sensitivity analyses were performed?"
			v-model="$tera.project.sensitivityAnalysis"
			placeholder="e.g. children who drank more than 8 litres a day"
			questionMark="metaanalysis-6"
		/>

		<InputTextMultiLine
			v-else
			question="Why was sensitivity analysis not performed?"
			v-model="$tera.project.whyNotSensitivityAnalysis"
			questionMark="metaanalysis-7"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import OutputSubgroupAndSensitivityAnalysis from "./OutputSubgroupAndSensitivityAnalysis.vue";

export default {
	name: "ViewMethodSubgroupAndSensitivityAnalysis",
	data() {
		return {
			outputComponent: OutputSubgroupAndSensitivityAnalysis
		};
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
